import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import { GET_VIEWUSERLIST } from '../../actions';
import { mediaUrl} from'../Config/Config';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import moment from 'moment';
class ViewEHR extends Component {

  constructor(props)
  {
    super(props); 
    const userid = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;

    this.state = {      
      userid: userid,
      userlistview:'',
      familtlistview:'',
      pastappointment:'',
      ongoingappts:'',
      futureappts:'',
      activetab: 'userdetail',  
      ShowFamilyDocuments:false,
      FamilyDocuments:'',
      medicalHistorylist:'',
      medicalCondition:'',
      ShowPrescriptionlist:'',
      Prescriptionlist:'',
      RaiseDisputelist:'',
      isActive:true,
    };

    var qs = require('qs');
    var postObject = {             
    id   :userid
    };
    this.props.getViewUserList(qs.stringify(postObject));  
  }

   
   componentDidMount() {
     document.title = PageTitle('User View');
     
    if ($('.sidebar-menu').hasClass('menu-close')) {
          $('.sidebar-menu').removeClass('menu-close');
          $('.logo-box').removeClass('active');	
            $('.header-cnt-left').removeClass('toggle-open');

      }else{
          $('.sidebar-menu').addClass('menu-close');
          $('.logo-box').addClass('active');
            $('.header-cnt-left').addClass('toggle-open');


      }
   }

   componentDidUpdate(prevProps,prevState){

   }
   componentWillReceiveProps(Props){
      if(Props.userlistview!==this.state.userlistview){
        if(Props.userlistview[0].status == "success"){
          this.setState({userlistview: Props.userlistview[0].userlistview[0]}) 
          this.setState({familtlistview: Props.userlistview[0].familylist}) 
          this.familylist();
          this.setState({pastappointment: Props.userlistview[0].pastappointment},function(){
            this.pastappointment();
          }) 
          this.setState({ongoingappts: Props.userlistview[0].ongoingappts},function(){
            this.ongoingappts();
          }) 
          this.setState({futureappts: Props.userlistview[0].futureappts},function(){
            this.futureappts();
          }) 
          this.setState({medicalHistorylist:Props.userlistview[0].usermedicalfiles},function(){
            this.medicalHistory();
          }) 
          this.setState({RaiseDisputelist:Props.userlistview[0].raise_dispute},function(){
            this.RaiseDisputelist();
          }) 
          this.setState({medicalCondition:Props.userlistview[0].medicalcondition},function(){
            this.medicalCondition();
          })
        }
      }
   }
   familylist() {
    var familtlist = this.state.familtlistview;
    if (familtlist != "undefined" && familtlist != null) {
      // if ( == "success"){
        if (Object.keys(familtlist).length > 0) {
          const familylistDetails = familtlist.map(
            (familtlist, Index) => {
              if(familtlist.gender == 'Male'){
                var gen = 'M';
              }else{
                var gen = 'F';
              }
              let sno = Index+1;
              return (
                <tr key={familtlist.id}>
				         <td>{sno}</td>
                 <td>
                  {familtlist.name} ({gen})
                  </td>
                   <td>
                  {familtlist.relationship}
                  </td>
                  <td>
                  {familtlist.age}
                  </td>
                  <td>
                  {familtlist.dob}
                  </td>
                  <td>
                  {familtlist.email}
                  </td>
                  <td>
                  {familtlist.contact_no!== null?familtlist.contact_no:'-'}
                  </td>
                  <td>
                  <a class="" title="View" href="#" onClick={this.ShowFamilyDocuments.bind(this,familtlist.family_member_documents)}>  <i class="ft-eye" aria-hidden="true"></i></a>
                  </td>
                 
                 
                </tr>
              );
            }
          );
          return familylistDetails;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }

  pastappointment() {
    var appointments = this.state.pastappointment;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
                 <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
                 <td>
                  {appts.medical_condition}
                  </td>
                  <td>
                  {appts.name}
                  </td>
                
                  <td>
                  {appts.gender}
                  </td>
                 
                  <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td>
                  <td>
                    {appts.prescriptionlist.length>0?
                    <a class="" title="View" href="#" onClick={this.apptPrescriptionShow.bind(this,appts.prescriptionlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:'N/A'}

                    
                  </td>
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }

  ongoingappts() {
    var appointments = this.state.ongoingappts;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
                 <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
                 <td>
                  {appts.medical_condition}
                  </td>
                  <td>
                  {appts.name}
                  </td>
                
                  <td>
                  {appts.gender}
                  </td>
                  <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td>
                  <td>
                    {appts.prescriptionlist.length>0?
                    <a class="" title="View" href="#" onClick={this.apptPrescriptionShow.bind(this,appts.prescriptionlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:'N/A'}

                    
                  </td>
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }
  apptPrescriptionShow = (preslist)=>{
    this.setState({ShowPrescriptionlist:true,Prescriptionlist:preslist});
  }
  apptPrescriptionlist = (preslist)=>{
 
    var preslist = this.state.Prescriptionlist;
    if (preslist != "undefined" && preslist != null) {
      // if ( == "success"){
        if (Object.keys(preslist).length > 0) {
          const apptDlist = preslist.map(
            (data, Index) => {
              let sno = Index+1;
            
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{data.prescription_name}</td>
                 <td>{data.quantity}</td>
                 <td>{data.price}</td>
                 {/* <td>{data.created_on}</td> */}
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
    
  }
  futureappts() {
    var appointments = this.state.futureappts;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
                 <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
                 <td>
                  {appts.medical_condition}
                  </td>
                  <td>
                  {appts.name}
                  </td>
                
                  <td>
                  {appts.gender}
                  </td>
                 
                  <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td>
                  <td>
                    {/* {appts.prescriptionlist.length>0?
                    <a class="" title="View" href="#" onClick={this.apptPrescriptionShow.bind(this,appts.prescriptionlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:''} */}

                    
                  </td>
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }
  medicalCondition = ()=>{
    var medicalCondition = this.state.medicalCondition;
    if (medicalCondition != "undefined" && medicalCondition != null) {
      // if ( == "success"){
        if (Object.keys(medicalCondition).length > 0) {
          const medlist = medicalCondition.map(
            (data, Index) => {
              let sno = Index+1;
              
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p>  {data.medical_condition} </p></td>
                 <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>
                 
                 
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }
  medicalHistory = ()=>{

    var medicalHistorylist = this.state.medicalHistorylist;
    if (medicalHistorylist != "undefined" && medicalHistorylist != null) {
      // if ( == "success"){
        if (Object.keys(medicalHistorylist).length > 0) {
          const medlist = medicalHistorylist.map(
            (medicalfile, Index) => {
              let sno = Index+1;
              
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p> <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="10.79 5 78.42 90" onClick={() => this.downloadImage(mediaUrl+"familymedical/"+medicalfile.image,medicalfile.image)} style={{width: '30px',height: '30px'}}
 > <g data-name="pdf"><path d="M87,25.34,70.92,7.75A8.46,8.46,0,0,0,64.69,5H19.23a8.45,8.45,0,0,0-8.44,8.44V86.56A8.45,8.45,0,0,0,19.23,95H80.77a8.45,8.45,0,0,0,8.44-8.44V31A8.4,8.4,0,0,0,87,25.34Zm-5.33,2.51H71.31A2.82,2.82,0,0,1,68.5,25V13.44Zm-.9,61.53H19.23a2.82,2.82,0,0,1-2.82-2.82V13.44a2.82,2.82,0,0,1,2.82-2.82H62.87V25a8.45,8.45,0,0,0,8.44,8.44H83.59V86.56A2.82,2.82,0,0,1,80.77,89.38Z"/><path d="M67.22,28.89,66.5,9H14.67V91.33H85.5V29.12ZM40.4,53.48a6.21,6.21,0,0,1-1.79,2.22A7.6,7.6,0,0,1,36,57a11.54,11.54,0,0,1-3.16.42H31.17a1,1,0,0,0-.94.94v5.24a.94.94,0,0,1-.94.94H26.44a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h6.27a14.69,14.69,0,0,1,3.26.34A7.33,7.33,0,0,1,38.61,45a5.54,5.54,0,0,1,1.79,2.09,7.06,7.06,0,0,1,.66,3.21A7.24,7.24,0,0,1,40.4,53.48Zm18.73,5.15A8.69,8.69,0,0,1,57,61.93a8.58,8.58,0,0,1-3.24,2,12.9,12.9,0,0,1-4.2.65H44.35a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h5a14.65,14.65,0,0,1,4.35.61A8.78,8.78,0,0,1,57,46a8.28,8.28,0,0,1,2.12,3.24,13.07,13.07,0,0,1,.75,4.67A13.36,13.36,0,0,1,59.13,58.63ZM75.82,46.58a.94.94,0,0,1-.94.94H68.26a.94.94,0,0,0-.94.94v3a.94.94,0,0,0,.94.94h5.4a.94.94,0,0,1,.94.94v2.12a.94.94,0,0,1-.94.94h-5.4a.94.94,0,0,0-.94.94v6.27a.94.94,0,0,1-.94.94H63.52a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94H74.88a.94.94,0,0,1,.94.94Z"/><path d="M53.37,48.76a4.33,4.33,0,0,0-1.87-1.08,8.5,8.5,0,0,0-2.45-.32h-.9V60.69h.9a7.84,7.84,0,0,0,2.45-.35,4.65,4.65,0,0,0,1.87-1.14,5.6,5.6,0,0,0,1.21-2.08A10.08,10.08,0,0,0,55,53.93a9.8,9.8,0,0,0-.43-3.14A5.23,5.23,0,0,0,53.37,48.76Z"/><path d="M35.39,48a5.42,5.42,0,0,0-3-.68H31.17a1,1,0,0,0-.94.94V52.7a1,1,0,0,0,.94.94h1.38q3.87,0,3.87-3.35A2.55,2.55,0,0,0,35.39,48Z"/></g></svg>  {medicalfile.image} </p></td>
                 <td>{moment(medicalfile.created_on).format('MMM DD Y hh:mm A')}</td>
                 
                 
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }

  }

  RaiseDisputelist = ()=>{
    
    var RaiseDisputelist = this.state.RaiseDisputelist;
    if (RaiseDisputelist != "undefined" && RaiseDisputelist != null) {
      // if ( == "success"){
        if (Object.keys(RaiseDisputelist).length > 0) {
          const medlist = RaiseDisputelist.map(
            (data, Index) => {
              let sno = Index+1;
              
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p>  {data.dispute} </p></td>
                 <td> <p>  {data.appointment_id} </p></td>
                 <td> <p>  {data.doctor_name} ({data.graduation}) </p></td>
                 <td> <p>  {data.dispute_message} </p></td>
                 {/* <td> <p>  {data.dispute_status=='A'?'Active':'Inactive'}</p></td> */}
                 
                 <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>
                                  
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }    
    }
  }
  handleGoBack = () => {
    if(this.state.ShowPrescriptionlist){
      this.setState({ShowPrescriptionlist:false});
    }else{
      this.props.history.goBack();
    }
    
  }
  handleClick = (index) => {
    this.setState({ activetab: index,ShowPrescriptionlist:false });
  };
  expandClick = () => {
    this.setState({ isActive: !this.state.isActive });
  };
  Capitalize(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
    }
    ShowFamilyDocuments=(documents)=>{
      this.setState({ShowFamilyDocuments:true,FamilyDocuments:documents});
    }
    downloadImage(url, name) {
			fetch(url)
			.then(resp => resp.blob())
			.then(blob => {
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = name;
				document.body.appendChild(link);
				link.click();
				window.URL.revokeObjectURL(url);
			})
			.catch(() => alert('An error sorry'));
		}
  render() {
    const { activetab } = this.state;
     if((this.state.userlistview.subscribed_plan_name!='')&&(this.state.userlistview.subscribed_plan_name!=null)){
        if(this.state.userlistview.subscribed_plan_name == "Free"){

         var plan_paid_amount = "$"+0;
        }else{
           var plan_paid_amount = "$"+this.state.userlistview.plan_paid_amount;
        }
    }else{
     var plan_paid_amount = "N/A";
    }

    if((this.state.userlistview.subscribed_plan_name!='')&&(this.state.userlistview.subscribed_plan_name!=null)){
        var subscribed_plan_name = this.state.userlistview.subscribed_plan_name;
    }else{
     var subscribed_plan_name = "N/A";
    }


    if((this.state.userlistview.transactionId!='')&&(this.state.userlistview.transactionId!=null)){
        var transactionId = this.state.userlistview.transactionId;
    }else{
     var transactionId = "N/A";
    }

    var mobileno = ((this.state.userlistview.mobileno === null)||((this.state.userlistview.mobileno === ''))) ?  this.state.userlistview.mobileno = 'N/A' : this.state.userlistview.mobileno;

    var lastname = ((this.state.userlistview.lastname === null)||(this.state.userlistview.lastname === "")) ?  this.state.userlistview.lastname = 'N/A' : this.state.userlistview.lastname;


    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="ongoingride" />  
      
      <div className="content"> 
        <div className="content-wrapper">
         <div class="content-wrapper-before"></div>
            <div className="content-body">
               <div className="form-wrapper leaa-admin-head card EMR-panel">
                 <div>
               
                  <span className='cursor-pointer btn-arrow end' onClick={this.handleGoBack}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg></span>
               </div> 
               <div className={`${this.state.isActive ? "vertical-menu-bar active" : "vertical-menu-bar"}`} onClick={this.expandClick}>
               {/* <svg version="1.1" x="0px" y="0px" viewBox="8 18 84 64" onClick={this.expandClick}><g transform="translate(0,-952.36218)"><path d="m 13,970.36219 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5 0,2.76149 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.23851 5,-5 0,-2.7615 -2.2386,-5 -5,-5 z m 0,26.99998 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5.00003 0,2.7615 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.2385 5,-5 0,-2.76153 -2.2386,-5.00003 -5,-5.00003 z m 0,27.00003 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5 0,2.7615 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.2385 5,-5 0,-2.7615 -2.2386,-5 -5,-5 z" fill="#000000" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg> */}
               <div>
               <h4>EMR</h4>
               <div>
               <span className="icon_menu1"></span>
                    <span className="icon_menu2"></span>
                    <span className="icon_menu3"></span>
                    </div>
                    </div>
               </div>
               <div className='d-flex w-100 gap-4 vertical-menu-content-wrapper mt-4 min-vh-100'>
               
                <ul className={`${this.state.isActive ? "vertical-menu-list active" : "vertical-menu-list"}`}>

                  <li onClick={() => this.handleClick('userdetail')} className={activetab === 'userdetail' ? 'active cursor-pointer' : ' cursor-pointer'}>
                   
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="5 3 22 26"><path d="M11,29H21a6,6,0,0,0,0-12H11a6,6,0,0,0,0,12Z"/><circle cx="16" cy="9" r="6"/></svg>
                    <span>User Demographics</span>   <span class="tooltip">User Info</span></li>
                  

                  <li onClick={() => this.handleClick('familylist')} className={activetab === 'familylist' ? 'active cursor-pointer' : ' cursor-pointer'}>
                  <svg version="1.1" x="0px" y="0px" viewBox="0 4.12 16.93 8.69"><g><path d="m 8.4644117,4.1224542 c -1.075782,0 -1.952477,0.879551 -1.952477,1.956487 0,0.68797 0.357561,1.294765 0.896555,1.643268 -1.055271,0.420591 -1.800127,1.452875 -1.800127,2.6600988 v 2.170979 a 0.2566142,0.2566142 0 0 0 0.255586,0.25759 h 5.2014283 a 0.2566142,0.2566142 0 0 0 0.257589,-0.25759 v -2.170979 c 0,-1.2072928 -0.74631,-2.2395368 -1.8021323,-2.6600988 0.5388233,-0.348535 0.8965563,-0.95543 0.8965563,-1.643268 0,-1.076936 -0.8771963,-1.956487 -1.9529783,-1.956487 z m -5.916567,0.93765 c -0.96514,0 -1.75201804,0.792879 -1.75201804,1.76154 0,0.599113 0.30070904,1.130258 0.75874004,1.448321 C 0.64056466,8.6599442 1.6641339e-6,9.5717782 1.6641339e-6,10.632383 v 1.920904 A 0.2566142,0.2566142 0 0 0 0.25608966,12.810877 H 4.8395997 a 0.2566142,0.2566142 0 0 0 0.255586,-0.25759 v -1.920904 c 0,-1.0608158 -0.640338,-1.9725538 -1.554565,-2.3624178 0.458109,-0.318053 0.759241,-0.849148 0.759241,-1.448321 0,-0.968661 -0.786878,-1.76154 -1.752017,-1.76154 z m 11.8361413,0 c -0.96514,0 -1.752017,0.792879 -1.752017,1.76154 0,0.599113 0.300709,1.130258 0.758739,1.448321 -0.914002,0.389979 -1.554565,1.301813 -1.554565,2.3624178 v 1.920904 a 0.2566142,0.2566142 0 0 0 0.256088,0.25759 h 4.58351 a 0.2566142,0.2566142 0 0 0 0.257591,-0.25759 v -1.920904 c 0,-1.0608178 -0.641806,-1.9725558 -1.55657,-2.3624178 0.458109,-0.318053 0.759241,-0.849148 0.759241,-1.448321 0,-0.968661 -0.786877,-1.76154 -1.752017,-1.76154 z" fill="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
                  <span>Family Members</span>
                    <i>{this.state.familtlistview.length}</i>
                    <span class="tooltip">Family Members</span>
                    </li>

                  <li onClick={() => this.handleClick('pastappointment')} className={activetab === 'pastappointment' ? 'active cursor-pointer' : ' cursor-pointer'}>
                   <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" x="0px" y="0px" viewBox="10.61 2.5 73.79 89.99"><path class="cls-1" d="M65.954,72.533H56.511v8.72l9.443-8.72Zm-4.7-35.017a1.107,1.107,0,0,1,0-2.214h3.079l1.289-4.372a1.1,1.1,0,0,1,2.125.026h0l2.028,7.567,3.472-6.216a1.1,1.1,0,0,1,2.029.252h0l.867,3.239.2-.755a1.106,1.106,0,0,1,1.068-.82v0h3.525a1.107,1.107,0,0,1,0,2.214H78.269l-1.045,3.91a1.105,1.105,0,0,1-2.139.013l-1.233-4.6-3.44,6.158a1.1,1.1,0,0,1-2.063-.193l-1.716-6.4-.389,1.324a1.108,1.108,0,0,1-1.082.872Zm-3.4-6.282c.478,5.329,4.468,12.249,13.242,17.509,8.775-5.26,12.765-12.18,13.242-17.509A9.036,9.036,0,0,0,83.7,26.67a4.813,4.813,0,0,0-2.473-2.506c-2.177-.931-5.422-.358-9.471,2.527a1.106,1.106,0,0,1-1.3.011c-4.055-2.9-7.306-3.471-9.486-2.538A4.813,4.813,0,0,0,58.5,26.67a9.036,9.036,0,0,0-.643,4.564ZM41.1,3.782a4.35,4.35,0,0,0-1.283,3.081A1.107,1.107,0,0,1,38.707,7.97H34.253v5.8a.225.225,0,0,0,.066.157l0,0,0,0a.219.219,0,0,0,.156.062h19.4a.226.226,0,0,0,.133-.042l.023-.024a.221.221,0,0,0,.066-.157V7.97H49.647a1.106,1.106,0,0,1-1.106-1.107A4.357,4.357,0,0,0,41.1,3.782ZM27.425,65.194a1.107,1.107,0,1,1,0-2.213h33.5a1.107,1.107,0,0,1,0,2.213ZM44.177,6.537a1.107,1.107,0,1,1,0-2.213h0a1.107,1.107,0,0,1,0,2.213Zm-2.27,5.551a1.107,1.107,0,1,1,0-2.213h4.541a1.107,1.107,0,0,1,0,2.213Zm-4.691,26.1H57.709a30.371,30.371,0,0,0,9.965,10.971V70.32H55.4A1.107,1.107,0,0,0,54.3,71.427V82.671H21.471a.8.8,0,0,1-.791-.791V69.6a5.7,5.7,0,0,0,1.453-1.665c.012-.02.023-.041.033-.061l6.743-11.68H60.93a1.107,1.107,0,0,0,0-2.213H30.187l3.92-6.79H60.93a1.107,1.107,0,0,0,0-2.213H35.385l1.22-2.113a1.1,1.1,0,0,0,.14-.428h0l.469-4.25ZM20.68,47.406l5.936-10.281a1.108,1.108,0,0,1,.315-.359l9.311-6.843a1.1,1.1,0,0,1,1.777.992l-.558,5.056H56.734a17.523,17.523,0,0,1-1.07-4.547,13.487,13.487,0,0,1-.018-2.243H27.425a1.107,1.107,0,1,1,0-2.213H56.044a9.172,9.172,0,0,1,.453-1.215,7,7,0,0,1,3.615-3.621c1.995-.853,4.564-.819,7.562.447V20.4a.8.8,0,0,0-.791-.792H21.471a.8.8,0,0,0-.791.792v27Zm-4.474,7.75,2.261-3.917V20.4a3.008,3.008,0,0,1,3-3H66.883a3.008,3.008,0,0,1,3,3V23.7q.6.351,1.215.764.531-.355,1.047-.664V12.64a.8.8,0,0,0-.791-.791H56.314V13.77a2.424,2.424,0,0,1-.714,1.721,1.007,1.007,0,0,1-.084.077,2.427,2.427,0,0,1-1.637.638h-19.4a2.434,2.434,0,0,1-1.719-.717l0,0a2.428,2.428,0,0,1-.714-1.721V11.849H17a.794.794,0,0,0-.79.791V55.156ZM13.992,69.872V85.988a3.008,3.008,0,0,0,3,3H66.551v2.716a.8.8,0,0,1-.791.791H11.4a.8.8,0,0,1-.791-.791V18.361a.794.794,0,0,1,.791-.791h2.594V58.99l-1.835,3.179c-.013.022-.025.045-.036.068a5.77,5.77,0,0,0,1.871,7.635Zm4.475.781V81.88a3.008,3.008,0,0,0,3,3H55.4a1.1,1.1,0,0,0,.8-.343l13.324-12.3a1.1,1.1,0,0,0,.356-.812h0V50.588c.211.127.423.253.639.378a1.1,1.1,0,0,0,1.129.014c.167-.1.331-.193.494-.291v35.3a.794.794,0,0,1-.791.791H17a.792.792,0,0,1-.79-.791V70.733a5.788,5.788,0,0,0,2.261-.08ZM28.875,38.077l5.763,3.328.489-4.431,0-.04.415-3.76-6.672,4.9ZM20.48,66.384l-6.156-3.553-.257.444-.03.049a3.554,3.554,0,0,0,6.186,3.5.653.653,0,0,1,.035-.056l.222-.385ZM22.085,63.6,15.93,60.049l-.5.87,6.156,3.553.5-.869Zm-5.053-5.462L23.187,61.7l4.09-7.083a1.091,1.091,0,0,1,.09-.156l6.367-11.029-6.155-3.554L17.032,58.141ZM23.121,56.9l6.432-11.141a1.1,1.1,0,0,0-1.91-1.1L21.21,55.805a1.1,1.1,0,0,0,1.911,1.1Z"></path></svg>
                    <span>Past Appts</span><i>{this.state.pastappointment.length}</i> <span class="tooltip">Past Appts</span></li>

                    <li onClick={() => this.handleClick('ongoingappts')} className={activetab === 'ongoingappts' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg>
                    <span>Ongoing Appts</span><i>{this.state.ongoingappts.length}</i><span class="tooltip">Ongoing Appts</span></li>

                    <li onClick={() => this.handleClick('futureappts')} className={activetab === 'futureappts' ? 'active cursor-pointer' : ' cursor-pointer'}>
                   <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="12 12.03 76 75.97">  <path d="m85.191 68.449c-2.582 2.2148-5.6758 3.75-9 4.4609-0.011718 3.6445-0.375 7.2773-1.0898 10.852 4.3594-4.3711 7.793-9.5781 10.09-15.312zm2.7812 4v11.102h-0.003906c0.011719 1.1719-0.44531 2.3008-1.2695 3.1367s-1.9453 1.3086-3.1211 1.3125h-6.9062c4.7969-4.3438 8.6523-9.625 11.328-15.52zm-13.871-3.5391c-0.55859-0.003906-1.0898 0.21484-1.4844 0.60938-0.39453 0.39062-0.61719 0.92578-0.61719 1.4805 0 5.7305-0.46094 12.719-2.7812 17h-52.797c-1.1758 0.003906-2.3008-0.46094-3.1289-1.293-0.83203-0.82812-1.2969-1.9531-1.293-3.1289v-52.668h76v29.148c-5.3945 5.9609-10.027 8.9102-13.898 8.8516zm-44.441-56.309c-0.55859-0.55859-1.3984-0.72266-2.125-0.41406-0.72656 0.30469-1.1953 1.0234-1.1836 1.8125v4.5117c0 0.78125 0.47266 1.4883 1.1953 1.7891 0.72656 0.29688 1.5586 0.13281 2.1133-0.42188 0.37109-0.35938 0.57812-0.85156 0.57812-1.3672v-4.5117c0-0.51562-0.20703-1.0117-0.57812-1.3711zm43.422 0h-0.003906c-0.57422-0.50781-1.3906-0.64062-2.0977-0.34375-0.70703 0.29688-1.1836 0.97656-1.2188 1.7422v4.5117c0.070312 1.0195 0.92188 1.8086 1.9414 1.8086 1.0234 0 1.875-0.78906 1.9453-1.8086v-4.5117c0-0.51562-0.20313-1.0078-0.57031-1.3711zm4.7617 5.7188h5.7383-0.003906c1.1719-0.003906 2.293 0.46094 3.125 1.2852 0.82812 0.82422 1.293 1.9453 1.2969 3.1133v4h-76v-4c0.003906-2.4219 1.9648-4.3867 4.3906-4.3984h5.7383c-0.066406 1.668 0.55078 3.2969 1.707 4.5 1.1602 1.207 2.7578 1.8867 4.4297 1.8867s3.2695-0.67969 4.4258-1.8867c1.1602-1.2031 1.7773-2.832 1.707-4.5h31.172c-0.066406 1.668 0.54688 3.2969 1.707 4.5 1.1562 1.207 2.7578 1.8867 4.4258 1.8867 1.6719 0 3.2734-0.67969 4.4297-1.8867 1.1602-1.2031 1.7734-2.832 1.707-4.5zm-15.414 28.68c-3.2969-3.2969-7.7695-5.1484-12.43-5.1484-4.6641 0-9.1367 1.8516-12.434 5.1484s-5.1484 7.7656-5.1484 12.43c0 4.6641 1.8516 9.1328 5.1484 12.43s7.7695 5.1523 12.434 5.1523c4.6602 0 9.1328-1.8555 12.43-5.1523 3.293-3.2969 5.1445-7.7695 5.1445-12.43 0-4.6602-1.8516-9.1328-5.1445-12.43zm-12.43-9.3281c-5.7734 0-11.312 2.293-15.395 6.375s-6.375 9.6211-6.375 15.395c0 5.7734 2.293 11.309 6.375 15.391 4.082 4.0859 9.6211 6.3789 15.395 6.3789s11.312-2.293 15.395-6.3789c4.082-4.082 6.375-9.6172 6.375-15.391 0-5.7734-2.293-11.312-6.375-15.395s-9.6211-6.375-15.395-6.375zm4.2188 16.129-6.3008 6.7812-2.1172-2.3438c-0.34766-0.46875-0.87891-0.76953-1.4609-0.82812-0.58203-0.058594-1.1602 0.12891-1.5938 0.51953-0.4375 0.39062-0.6875 0.94141-0.69531 1.5273-0.007812 0.58594 0.23438 1.1445 0.66016 1.543l3.5508 4c0.375 0.48047 0.94531 0.76953 1.5547 0.79297 0.60938 0.027343 1.1992-0.21484 1.6133-0.66406l7.8516-8.4414v0.003906c0.38672-0.41016 0.59375-0.96094 0.57422-1.5234-0.019531-0.56641-0.26562-1.0977-0.68359-1.4766-0.40625-0.37891-0.94531-0.58203-1.5-0.55859-0.55469 0.019532-1.0781 0.25781-1.4531 0.66797z" fill-rule="evenodd"></path> </svg>
                    <span>Future Appts</span><i>{this.state.futureappts.length}</i><span class="tooltip">Future Appts</span></li>

                    <li onClick={() => this.handleClick('RaiseDisputelist')} className={activetab === 'RaiseDisputelist' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg version="1.1" x="0px" y="0px" viewBox="18 6.5 64 87"><g transform="translate(0,-952.36218)"><path d="m 18,958.86216 0,87.00004 48,0 0,-14 c 0.01,-0.9745 0.9163,-1.989 2,-2 l 14,0 0,-71.00004 z m 12,9 40,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -40,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z m 0,18 40,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -40,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z m 0,18.00004 40,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -40,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z m 0,18 40,0 c 1.1046,0 2,0.8954 2,2 0,1.1046 -0.8954,2 -2,2 l -40,0 c -1.1046,0 -2,-0.8954 -2,-2 0,-1.1046 0.8954,-2 2,-2 z m 40,12 0,10 10,-10 z" fill="#000000" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg>
                   <span>Raised Disputes</span><i>{this.state.RaiseDisputelist.length}</i><span class="tooltip">Raised Disputes</span></li>

                    <li onClick={() => this.handleClick('medical_list')} className={activetab === 'medical_list' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="77.38 31.95 345.25 436.1"><path clipRule="evenodd" d="M113.718,31.949c-20.079,0-36.343,16.264-36.343,36.34v363.421  c0,20.078,16.264,36.34,36.343,36.34h272.566c20.079,0,36.34-16.262,36.34-36.34V158.417c0-12.173-4.81-22.982-12.536-30.796  l-82.497-82.319c-8.173-8.265-19.628-13.352-32.164-13.352H113.718z M240.914,95.548c0-9.996,8.177-18.173,18.172-18.173  c9.991,0,18.172,8.177,18.172,18.173v68.14c0,7.542,6.087,13.629,13.626,13.629h68.143c9.99,0,18.172,8.175,18.172,18.17  c0,9.996-8.182,18.171-18.172,18.171h-81.769c-20.079,0-36.344-16.264-36.344-36.341V95.548z" fill="#000000" fillRule="evenodd"></path></svg>
                    <span>Medical Histories</span> <i>{this.state.medicalHistorylist.length}</i><span class="tooltip">Medical Histories</span> </li> 

                    <li onClick={() => this.handleClick('medical_condition')} className={activetab === 'medical_condition' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="77.38 31.95 345.25 436.1"><path clipRule="evenodd" d="M113.718,31.949c-20.079,0-36.343,16.264-36.343,36.34v363.421  c0,20.078,16.264,36.34,36.343,36.34h272.566c20.079,0,36.34-16.262,36.34-36.34V158.417c0-12.173-4.81-22.982-12.536-30.796  l-82.497-82.319c-8.173-8.265-19.628-13.352-32.164-13.352H113.718z M240.914,95.548c0-9.996,8.177-18.173,18.172-18.173  c9.991,0,18.172,8.177,18.172,18.173v68.14c0,7.542,6.087,13.629,13.626,13.629h68.143c9.99,0,18.172,8.175,18.172,18.17  c0,9.996-8.182,18.171-18.172,18.171h-81.769c-20.079,0-36.344-16.264-36.344-36.341V95.548z" fill="#000000" fillRule="evenodd"></path></svg>
                    <span>Medical Conditions</span><i>{this.state.medicalCondition.length}</i><span class="tooltip">Medical Conditions</span> </li> 
                
                </ul>
                <div className="vertical-menu-content">
                
                      <div className={activetab === 'userdetail' ?"content-div userdetail active":"content-div userdetail"} id="userdetail">
                      <div className="title text-start">
                      <h3>User Demographics</h3>
                      </div>
                      <div className="form-row">
                        <div className="details_left">
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Username<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.userlistview.username}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Firstname<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.userlistview.firstname}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Lastname<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{lastname}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Email<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.userlistview.email}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Mobile number<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{mobileno}</p>
                              </div>
                              
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>User Type<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{ this.state.userlistview.user_type && `${this.Capitalize(this.state.userlistview.user_type)}`}</p>
                              </div>
                            </div>

                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Location<span>:</span></p>
                              </div>
                            <div className="view-details-two">
                                  <p>{ this.state.userlistview.location}</p>
                              </div>
                            </div>

                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Plan type<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{subscribed_plan_name}</p>
                              </div>
                              
                            </div>

                            {/* <div className="view-details">
                              <div className="view-details-one">
                                  <p>Paid Plan amount<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{plan_paid_amount}</p>
                              </div>
                            </div> */}

                             {/*  <div className="view-details">
                              <div className="view-details-one">
                                  <p>Transaction ID<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{transactionId}</p>
                              </div>
                              </div> */}
                              {(this.state.userlistview.admin_type!== null && this.state.userlistview.adminname!== undefined) && <div className="view-details">
                              <div className="view-details-one">
                                  <p>Status Changed by<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.userlistview.adminname+' ('+this.state.userlistview.admin_type+')'}</p>
                              </div>
                              </div>}


                        </div>
                      </div>
                      </div>
                      <div className={activetab === 'familylist' ?"content-div familylist active":"content-div familylist"} id="familylist">
                      <div className="title text-start">
                        <h3>{this.state.ShowFamilyDocuments==false?'Family Members':'Medical Documents'}</h3>
                      </div>
                      {this.state.ShowFamilyDocuments==false?
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Relationship</th>
                                <th>Age</th>
                                <th>DOB</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Document</th>
                              </tr>
                            </thead>
                            <tbody>{this.familylist()}
                            </tbody>
                          </Table>
                        </div>:
                           <>{this.state.FamilyDocuments.map(
                              (file, Index) => {                                
                                return (
                                  <div className="form-row EHR-view">
                                  <div className="details_left">                               
                                        <div className="view-details-two m-0">
                                            <p onClick={() => this.downloadImage(mediaUrl+"familymedical/"+file.image,file.image)} >   
                                              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="10.79 5 78.42 90"><g data-name="pdf"><path d="M87,25.34,70.92,7.75A8.46,8.46,0,0,0,64.69,5H19.23a8.45,8.45,0,0,0-8.44,8.44V86.56A8.45,8.45,0,0,0,19.23,95H80.77a8.45,8.45,0,0,0,8.44-8.44V31A8.4,8.4,0,0,0,87,25.34Zm-5.33,2.51H71.31A2.82,2.82,0,0,1,68.5,25V13.44Zm-.9,61.53H19.23a2.82,2.82,0,0,1-2.82-2.82V13.44a2.82,2.82,0,0,1,2.82-2.82H62.87V25a8.45,8.45,0,0,0,8.44,8.44H83.59V86.56A2.82,2.82,0,0,1,80.77,89.38Z"/><path d="M67.22,28.89,66.5,9H14.67V91.33H85.5V29.12ZM40.4,53.48a6.21,6.21,0,0,1-1.79,2.22A7.6,7.6,0,0,1,36,57a11.54,11.54,0,0,1-3.16.42H31.17a1,1,0,0,0-.94.94v5.24a.94.94,0,0,1-.94.94H26.44a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h6.27a14.69,14.69,0,0,1,3.26.34A7.33,7.33,0,0,1,38.61,45a5.54,5.54,0,0,1,1.79,2.09,7.06,7.06,0,0,1,.66,3.21A7.24,7.24,0,0,1,40.4,53.48Zm18.73,5.15A8.69,8.69,0,0,1,57,61.93a8.58,8.58,0,0,1-3.24,2,12.9,12.9,0,0,1-4.2.65H44.35a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h5a14.65,14.65,0,0,1,4.35.61A8.78,8.78,0,0,1,57,46a8.28,8.28,0,0,1,2.12,3.24,13.07,13.07,0,0,1,.75,4.67A13.36,13.36,0,0,1,59.13,58.63ZM75.82,46.58a.94.94,0,0,1-.94.94H68.26a.94.94,0,0,0-.94.94v3a.94.94,0,0,0,.94.94h5.4a.94.94,0,0,1,.94.94v2.12a.94.94,0,0,1-.94.94h-5.4a.94.94,0,0,0-.94.94v6.27a.94.94,0,0,1-.94.94H63.52a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94H74.88a.94.94,0,0,1,.94.94Z"/><path d="M53.37,48.76a4.33,4.33,0,0,0-1.87-1.08,8.5,8.5,0,0,0-2.45-.32h-.9V60.69h.9a7.84,7.84,0,0,0,2.45-.35,4.65,4.65,0,0,0,1.87-1.14,5.6,5.6,0,0,0,1.21-2.08A10.08,10.08,0,0,0,55,53.93a9.8,9.8,0,0,0-.43-3.14A5.23,5.23,0,0,0,53.37,48.76Z"/><path d="M35.39,48a5.42,5.42,0,0,0-3-.68H31.17a1,1,0,0,0-.94.94V52.7a1,1,0,0,0,.94.94h1.38q3.87,0,3.87-3.35A2.55,2.55,0,0,0,35.39,48Z"/></g></svg> 
                                             {file.image} </p> 
                                        </div>
                                  </div>  
                                  {/* <div className='frame open'>
                                  <iframe  class="responsive-iframe"  src={mediaUrl+"familymedical/"+file.image}>       
                                  </iframe>
                                  </div> */}

                                  </div>
                                );
                              }
                            )}                          
                         </>
                         }
                        
                      </div>
                      <div className={activetab === 'pastappointment' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                       
                      {this.state.ShowPrescriptionlist==true? <h3> Appointment Prescriptions</h3>: <h3>Past Appointments</h3>} 

                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            {this.state.ShowPrescriptionlist==true?
                              <tr>
                              <th>S.No</th>                              
                              <th>Medicine </th>
                              <th>Quantity</th>
                              <th>Price</th>
                            </tr>:
                              <tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Schedule On</th>
                                <th>Reason</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th>
                                <th>Prescription</th>
                              </tr>}
                            </thead>
                            {this.state.ShowPrescriptionlist==true?<tbody> {this.apptPrescriptionlist()}<br/>
                            </tbody>:
                            <tbody> {this.pastappointment()}<br/>
                            
                            </tbody>}
                          </Table>
                          {/* <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalRecord}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            />
                          </div> */}
                        </div>
                      </div>

                      <div className={activetab === 'ongoingappts' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                      {this.state.ShowPrescriptionlist==true? <h3> Appointment Prescriptions</h3>: <h3>Ongoing Appointments</h3>}
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            {this.state.ShowPrescriptionlist==true?
                              <tr>
                              <th>S.No</th>                              
                              <th>Medicine </th>
                              <th>Quantity</th>
                              <th>Price</th>
                            </tr>:<tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Schedule On</th>
                                <th>Reason</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th>
                                <th>Prescription</th>
                              </tr>}
                            </thead>
                            {this.state.ShowPrescriptionlist==true?<tbody> {this.apptPrescriptionlist()}<br/>
                            </tbody>:
                            <tbody> {this.ongoingappts()}<br/>
                            </tbody>}
                          </Table>
                          {/* <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalRecord}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            />
                          </div> */}
                        </div>
                      </div>


                      <div className={activetab === 'futureappts' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                     <h3>Future Appointments</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            
                              <tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Schedule On</th>
                                <th>Reason</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th>
                                {/* <th>Action</th> */}
                              </tr>
                            </thead>                           
                            <tbody> {this.futureappts()}<br/>
                            </tbody>
                          </Table>
                          {/* <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalRecord}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            />
                          </div> */}
                        </div>
                      </div>

                      <div className={activetab === 'RaiseDisputelist' ?"content-div RaiseDisputelist active":"content-div RaiseDisputelist"} id="RaiseDisputelist">
                      <div className="title text-start">
                        <h3>Raised Disputes</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Dispute</th>
                                <th>Appt ID</th>
                                <th>Provider</th>
                                <th>Comment</th>
                                {/* <th>Status</th> */}
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.RaiseDisputelist()}<br/>
                            
                            </tbody>
                          </Table>
                         
                        </div>
                      </div>

                      <div className={activetab === 'medical_list' ?"content-div medical_list active":"content-div medical_list"} id="medical_list">
                      <div className="title text-start">
                        <h3>Medical Histories</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>File</th>
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.medicalHistory()}<br/>
                            
                            </tbody>
                          </Table>
                         
                        </div>
                      </div>

                      <div className={activetab === 'medical_condition' ?"content-div medical_condition active":"content-div medical_condition"} id="medical_condition">
                      <div className="title text-start">
                        <h3>Medical Conditions</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Medical Condition</th>
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.medicalCondition()}<br/>                            
                            </tbody>
                          </Table>                         
                        </div>
                      </div>
                   
                </div>
              </div>
             
                  
              </div>            
            
          </div>
         </div> 
        </div>        
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    userlistview: state.userlistview
    
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getViewUserList: (userid) =>{
       dispatch({ type: GET_VIEWUSERLIST,userid });
    },
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(ViewEHR));